<form [formGroup]="form" class="form-font-size">
  <textarea
    rows="3"
    pInputTextarea
    ui-inputText
    formControlName="message"
    placeholder="Type a message"
    maxlength="500"
    (keydown.control.enter)="sendMessage()"
    tabindex="0"
    appEnterClick></textarea>
  <button [disabled]="!form.valid || isSendingMessage" (click)="sendMessage()" pButton type="button" tabindex="0" appEnterClick>
    {{ 'send-button-label' | translate }}
  </button>
</form>
